import type { MemberHandicap } from '../types/api.types';

interface MemberHandicapsProps {
  memberHandicaps: MemberHandicap[];
}

export default function MemberHandicaps({ memberHandicaps }: MemberHandicapsProps) {
  if (!memberHandicaps || memberHandicaps.length === 0) {
    return <h1>No Data</h1>;
  }

  const rows = memberHandicaps.map((handicap) => (
    <tr key={handicap.id}>
      <td>{`${handicap.firstName} ${handicap.lastName}`}</td>
      <td>{handicap.handicap}</td>
    </tr>
  ));

  return (
    <div className="container">
      <h1>Handicaps</h1>
      <table className="table">
        <thead>
          <tr>
            <th>Member</th>
            <th>Handicap</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}
